export default "__VITE_PUBLIC_ASSET__2be0e927__"